import React, { useState } from "react";

const Questions = (props) => {
  let q = props.value || [];
  return q.map((el, index) => (
    <div className="mb-5" key={"p" + index}>
      <h3 style={{ fontSize: "28px" }}>
        {index + 1}. {el.question}
      </h3>
      {el.answer && el.answer.length > 0 ? (
        el.answer.map((ans, index2) => (
          <div
            style={{ fontSize: "20px" }}
            className="form-check"
            key={"p" + index + "a" + index2}
          >
            <input
              style={{ fontSize: "20px" }}
              className="form-check-input"
              type={el.type === "single" ? "radio" : "checkbox"}
            />{" "}
            {ans}
          </div>
        ))
      ) : (
        <input type="text" className="form-control" />
      )}
    </div>
  ));
};

export default Questions;
